export default __webpack_public_path__ + "static/media/vote.3ba5c2d0.svg";